import { render, staticRenderFns } from "./recordedInfo.vue?vue&type=template&id=66d3ae8e&scoped=true"
import script from "./recordedInfo.vue?vue&type=script&lang=js"
export * from "./recordedInfo.vue?vue&type=script&lang=js"
import style0 from "./recordedInfo.vue?vue&type=style&index=0&id=66d3ae8e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66d3ae8e",
  null
  
)

export default component.exports